//"produce" | "join" | "both"
export enum BulkProduceTypeEnum {
  Produce = "produce",
  Join = "join",
  Both = "both",
}
